// TODO : This component simply displays the test meta data and allows the user to edit it
// The bound data passed in is then saved in the parent component.
// So as it is not very re-usable if there is time we should re-work the parent so we can have
// one component to display the test list and another to edit the test info.
class TestCaseRequirementsController {
    constructor(toastr) {
        // Used because $onChanges can fire before $onInit
        this.isInitialized = false;
        this.$onInit = () => {
            if (!this.isInitialized) {
                this.state = {};
                this.data = {};
                this.data.showTestCaseRequirements = false;
                this.isInitialized = true;
            }
        };
        this.$onChanges = (changes) => {
            // Make sure we're initialized
            this.$onInit();
            if (changes.showUpdated) {
                this.state.showUpdated = changes.showUpdated.currentValue;
            }
            if (changes.selectedTest) {
                this.state.selectedTest = changes.selectedTest.currentValue;
            }
            if (changes.testCaseMetadataList) {
                this.data.testCaseMetadataList =
                    changes.testCaseMetadataList.currentValue;
                this.data.showTestCaseRequirements = false;
                if (this.data.testCaseMetadataList !== undefined && this.data.testCaseMetadataList !== null) {
                    let idx = 0;
                    for (idx = 0; idx < this.data.testCaseMetadataList.length; idx++) {
                        let testCaseRequirement = this.data.testCaseMetadataList[idx];
                        if (testCaseRequirement.Key.length > 0) {
                            this.data.showTestCaseRequirements = true;
                            break;
                        }
                    }
                }
            }
            if (changes.testCaseMetadataUpdate) {
                this.data.testCaseMetadataUpdate =
                    changes.testCaseMetadataUpdate.currentValue;
            }
        };
        this.clear = () => {
            // Clear Information text Area
            this.data.testCaseMetadataUpdate.TestCase.TestCaseInformation = '';
            this.data.testCaseMetadataUpdate.TestCase.TestCaseInfoChars = 0;
            // Loop and clear checkboxes
            angular.forEach(this.data.testCaseMetadataUpdate.TestCaseXmlKVPList, (t) => {
                t.Value = false;
                // console.log(t);
            }, this);
            // Update list which is the source of the checkboxes
            this.data.testCaseMetadataList = this.data.testCaseMetadataUpdate.TestCaseXmlKVPList;
        };
        this.toastr = toastr;
    }
}
// component deletes the test suite passed in and makes the API call to mark it as deleted
// when the button is clicked.
angular.module('app').component('testCaseRequirements', {
    bindings: {
        selectedTest: '<',
        showUpdated: '<',
        testCaseMetadataList: '<',
        testCaseMetadataUpdate: '<'
    },
    templateUrl: 'scripts/app/partials/ManageTestSuites/TestCases/test-case-requirements.tpl.html',
    controllerAs: 'vm',
    controller: TestCaseRequirementsController
});
